import React from 'react';
import styled from 'styled-components';
import { useTranslation } from '~/Locale';
import { COLORS, START_LIVES } from '../constants';

const Row = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
`;

const Item = styled.div<{ withDivider?: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  ${({ withDivider }) =>
    withDivider ? 'border-left: 1px solid #333; padding-left: 10px;' : ''}
`;

const Label = styled.span`
  font-size: 9px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: #888;
  font-weight: 700;
`;

const Value = styled.span<{ color: string; small?: boolean }>`
  font-size: ${({ small }) => (small ? '14px' : '16px')};
  font-weight: 800;
  color: ${({ color }) => color};
  line-height: 1.1;
`;

export interface HudProps {
  score: number;
  deals: number;
  lives: number;
  best: number;
}

const hearts = (lives: number) =>
  Array.from({ length: START_LIVES }, (_, i) => (i < lives ? '♥' : '♡')).join(
    ''
  );

const Hud = ({ score, deals, lives, best }: HudProps) => {
  const { t } = useTranslation();

  return (
    <Row>
      <Item>
        <Label>{t('Score')}</Label>
        <Value color={COLORS.yellow}>{score}</Value>
      </Item>
      <Item>
        <Label>{t('Stars')}</Label>
        <Value color={COLORS.teal}>{deals}</Value>
      </Item>
      <Item>
        <Label>{t('Lives')}</Label>
        <Value color={COLORS.coral}>{hearts(lives)}</Value>
      </Item>
      <Item withDivider>
        <Label>{t('Record')}</Label>
        <Value color={COLORS.teal} small>
          {best}
        </Value>
      </Item>
    </Row>
  );
};

export default Hud;
